import { render } from "./ConfigDemo.vue?vue&type=template&id=0f9b6042"
import script from "./ConfigDemo.vue?vue&type=script&lang=js"
export * from "./ConfigDemo.vue?vue&type=script&lang=js"

import "./ConfigDemo.vue?vue&type=style&index=0&id=0f9b6042&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__